// Copyright 2016 Sorama B.V.

import { autoinject, computedFrom } from "aurelia-framework";
import { Router } from "aurelia-router";
import { HomeGuidanceCatalog } from "catalogs/GuidanceCatalog/HomeGuidanceCatalog";
import { RepresentativeDTO } from "datatypes/SoramaWebApi";
import { IAuthentication } from "libraries/Authentication/IAuthentication";
import { ShellViewManager } from "modules/shell/App/ShellViewManager";
import { AccountRepository } from "repositories/AccountRepository";
import { RepresentativeRepository } from "repositories/RepresentativeRepository";
import { ILicenseService } from "services/License/ILicenseService";
import { IProjectManagementService } from "services/Project/IProjectManagementService";
import { WorkflowModeService } from "services/WorkflowModes/WorkflowModeService";
@autoinject
export class HomeView {
    static personalizedPage = "/Metadata/PersonalizedPage";
    public representative: RepresentativeDTO;
    private businessUnitId: string;

    // Properties for workflow modes
    protected isIndustrial: boolean;
    protected isBuilding: boolean;

    constructor(
        private readonly shellviewManager: ShellViewManager,
        private readonly authentication: IAuthentication,
        private readonly projectManagementService: IProjectManagementService,
        private readonly representativeRepository: RepresentativeRepository,
        private readonly accountRepository: AccountRepository,
        private readonly workflowModeService: WorkflowModeService,
        private readonly router: Router,
        private readonly licenseService: ILicenseService
    ) {}

    public async bind(): Promise<void> {
        // Load representative and business unit data
        try {
            const [representative, businessUnitId] = await Promise.all([
                this.representativeRepository.getRepresentative(this.authentication.userId),
                this.accountRepository.getBusinessUnitId(),
            ]);
            this.representative = representative;
            this.businessUnitId = businessUnitId;
        } catch (e) {
            console.error(e);
        }
    }

    public openHelpSection(): void {
        this.shellviewManager.openRightSideBarHelp(HomeGuidanceCatalog.HomeOverviewModule.name);
    }

    @computedFrom("workflowModeService.selectedWorkflowMode")
    protected get canSeeTimeLine(): boolean {
        return this.authentication.isSignedIn && this.workflowModeService.selectedWorkflowMode.canDoMeasurementAnalysis;
    }

    @computedFrom("projectManagementService.measurements")
    protected get hasTimeLineItems(): boolean {
        return this.projectManagementService.measurements.item.length > 0;
    }

    @computedFrom("workflowModeService.selectedWorkflowMode")
    protected get showDeviceSelection(): boolean {
        return this.workflowModeService.selectedWorkflowMode.canConnectDevice;
    }

    private redirectToReportingModule(): void {
        this.router.navigate("/Reporting");
    }
}
